var jCube = require('./core');
var vars = require('./variables');

jCube.fn.toggle = function (force) {
    return this.each(function (index, element) {
        force = force !== undefined ? force : jCube.isHidden(element);

        if (force) {
            element.style.display = '';

            if (jCube.isHidden(element)) {
                element.style.display = jCube.getDefaultDisplay(element.tagName);
            }
        } else {
            element.style.display = 'none';
        }
    });
};

jCube.fn.hide = function () {
    return this.toggle(false);
};

jCube.fn.show = function () {
    return this.toggle(true);
};

jCube.fn.hasClass = function (cls) {
    return cls && vars.some.call(this, function (ele) {
        return ele.classList.contains(cls);
    });
};

jCube.fn.toggleClass = function (cls, force) {
    var classes = jCube.h.getSplitValues(cls),
        isForce = force !== undefined;
    if (!classes.length) return this;
    this.each(function (i, ele) {
        jCube.each(classes, function (i, c) {
            if (isForce) {
                force ? ele.classList.add(c) : ele.classList.remove(c);
            } else {
                ele.classList.toggle(c);
            }
        });
    });

    return this;
};

jCube.fn.addClass = function (cls) {
    return this.toggleClass(cls, true);
};

jCube.fn.removeClass = function (cls) {
    return !arguments.length ? this.attr('class', '') : this.toggleClass(cls, false);
};